export {
  default as tanningEdge,
  ReactComponent as TanningEdge,
} from '@assets/icons/features-and-amenities/tanning-edge.svg'    
